import { useState, useContext, useEffect } from "react";
import {
  Button,
  AddIcon,
  Pane,
  TextInputField,
  Heading,
  SelectField,
  Checkbox,
  Spinner,
  Textarea,
  Tablist,
  Tab,
} from "evergreen-ui";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import moment from "moment";
import { globalContext } from "../global/Store";
import { dataRepoContext } from "../data-repo/DataRepo";
// @ts-ignore
import styled from "styled-components";
import {
  CaseRoot, CaseUpdate
} from "../global/Types";

export const MainDetailsStyle = styled.div`
  input:disabled {
    cursor: default;
  }

  select:disabled {
    cursor: default;
  }

  textarea:disabled {
    cursor: default;
  }
`;

const CaseMainDetails = (props: any) => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);
  const { globalDataRepo } = useContext(dataRepoContext);
  //const [selectedCase, setSelectedCase] = useState(props.case);

  const [selectedCase, setSelectedCase] = useState<CaseRoot>(
    { ...props.case } as CaseRoot
  );

  const [applicant1NameInvalid, setApplicant1NameInvalid] = useState(false);
  const [applicant1PhoneInvalid, setApplicant1PhoneInvalid] = useState(false);
  const [applicant1AddressInvalid, setApplicant1AddressInvalid] = useState(false);
  const [applicant1TownInvalid, setApplicant1TownInvalid] = useState(false);
  const [applicant1PostcodeInvalid, setApplicant1PostcodeInvalid] = useState(false);
  const [applicant1EmploymentStatusInvalid, setApplicant1EmploymentStatusInvalid] = useState(false);
  const [applicant1OtherPropertyOwnedInvalid, setApplicant1OtherPropertyOwnedInvalid] = useState(false);
  const [applicant1OtherPropertySoldInvalid, setApplicant1OtherPropertySoldInvalid] = useState(false);
  const [propertyStatusIdInvalid, setPropertyStatusIdInvalid] = useState(false);
  const [developmentIdInvalid, setDevelopmentIdInvalid] = useState(false);
  const [purchasePriceInvalid, setPurchasePriceInvalid] = useState(false);
  const [plotNumberInvalid, setPlotNumberInvalid] = useState(false);
  const [managerNameInvalid, setManagerNameInvalid] = useState(false);
  const [depositLevelInvalid, setDepositLevelInvalid] = useState(false);
  const [serviceChargeInvalid, setServiceChargeInvalid] = useState(false);
  const [schemeInvalid, setSchemeInvalid] = useState(false);
  const [minPercShareInvalid, setMinPercShareInvalid] = useState(false);
  const [housingAssociationInvalid, setHousingAssociationInvalid] = useState(false);
  const [propertyTypeInvalid, setPropertyTypeInvalid] = useState(false);
  const [buyerTypeInvalid, setBuyerTypeInvalid] = useState(false);
  const [appointmentInvalid, setAppointmentInvalid] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showAssignCaseDetails, setShowAssignCaseDetails] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [showFormLoading, setShowFormLoading] = useState(false);
  const [schemes, setSchemes] = useState(<></>);
  const [developments, setDevelopments] = useState(<></>);
  const [employmentStatuses, setEmploymentStatuses] = useState(<></>);
  const [propertyStatuses, setPropertyStatuses] = useState(<></>);
  const [propertyTypes, setPropertyTypes] = useState(<></>);
  const [buyerTypes, setBuyerTypes] = useState(<></>);
  const [stressTestingRentPayments, setStressTestingRentPayments] = useState(<></>);
  const [appointmentTypes, setappointmentTypes] = useState(<></>);
  const [disabledInput, setDisabledInput] = useState(
    (selectedCase?.caseStatusId === 66 && selectedCase?.referredById === globalState.user.userId) ?
      false : true
  );

  const [cashBuyer, setCashBuyer] = useState(selectedCase.cashBuyer === 1 ? true : false);
  const validationMessage = "This field is required";

  const selectedCaseStatus = globalState.caseStatuses.find(
    (e: any) => e.id === props.case?.caseStatusId
  )?.description;

  const applicantTabSelected = (_tab: any) => {
    setSelectedIndex(_tab);
  };

  // Set up dropdown lists
  useEffect(() => {
    setShowFormLoading(true);
    console.log("useEffect", selectedCase)
    var pSchemes = getSchemes();
    var pDevelopments = getDevelopments();
    var pEmpStatuses = getEmploymentStatuses();
    var pPropStatuses = getPropertyStatuses();
    var pPropertyTypes = getPropertyTypes();
    var pBuyerTypes = getBuyerTypes();
    var pStressTestingRentPayments = getStressTestingRentPayments();
    var pAppointmentType = getappintmentTypes();


    Promise.allSettled([
      pSchemes,
      pDevelopments,
      pEmpStatuses,
      pPropStatuses,
      pPropertyTypes,
      pBuyerTypes,
      pStressTestingRentPayments,
      pAppointmentType
    ]).then(() => {
      setShowFormLoading(false);
    });
    console.log(selectedCase, "selectedCase")
  }, []);


  const validate = () => {
    return new Promise<void>(function (resolve, reject) {
      var hasError = false;

      // Reset from previous validation
      setPropertyStatusIdInvalid(false);
      setDevelopmentIdInvalid(false);
      setPurchasePriceInvalid(false);
      setPlotNumberInvalid(false);
      setManagerNameInvalid(false);
      setDepositLevelInvalid(false);
      setServiceChargeInvalid(false);
      setSchemeInvalid(false);
      setMinPercShareInvalid(false);
      setHousingAssociationInvalid(false);
      setApplicant1NameInvalid(false);
      setApplicant1PhoneInvalid(false);
      setApplicant1AddressInvalid(false);
      setApplicant1TownInvalid(false);
      setApplicant1PostcodeInvalid(false);
      setApplicant1EmploymentStatusInvalid(false);
      setApplicant1OtherPropertyOwnedInvalid(false);
      setApplicant1OtherPropertySoldInvalid(false);
      setPropertyTypeInvalid(false);
      setBuyerTypeInvalid(false);
      setAppointmentInvalid(false);

      // Case
      if (!selectedCase.propertyStatusId) {
        setPropertyStatusIdInvalid(true);
        hasError = true;
      }

      // if (!selectedCase.appointmentTypeId) {
      //   setAppointmentInvalid(true);
      //   hasError = true;
      // }


      if (!selectedCase.developmentId) {
        setDevelopmentIdInvalid(true);
        hasError = true;
      }

      if (!selectedCase.purchasePrice) {
        setPurchasePriceInvalid(true);
        hasError = true;
      }

      if (!selectedCase.plotNumber) {
        setPlotNumberInvalid(true);
        hasError = true;
      }

      if (!selectedCase.managerName) {
        setManagerNameInvalid(true);
        hasError = true;
      }

      if (!selectedCase.depositLevel) {
        setDepositLevelInvalid(true);
        hasError = true;
      }

      if (!selectedCase.serviceCharge) {
        setServiceChargeInvalid(true);
        hasError = true;
      }

      if (!selectedCase.schemeId) {
        setSchemeInvalid(true);
        hasError = true;
      }

      if (!selectedCase.propertyTypeId) {
        setPropertyTypeInvalid(true);
        hasError = true;
      }

      if (!selectedCase.buyerTypeId) {
        setBuyerTypeInvalid(true);
        hasError = true;
      }

      // If its shared owndership, further checks are needed selectedCase.so === 1
      if (selectedCase.schemeId === 171) {
        if (!selectedCase.minPercShareAvailable) {
          setMinPercShareInvalid(true);
          hasError = true;
        }

        if (!selectedCase.housingAssociation) {
          setHousingAssociationInvalid(true);
          hasError = true;
        }
      }

      // Applicant
      if (!selectedCase.applicants[0].applicantName) {
        setApplicant1NameInvalid(true);
        setSelectedIndex(0);
        hasError = true;
      }

      if (!selectedCase.applicants[0].applicantPhone1) {
        setApplicant1PhoneInvalid(true);
        setSelectedIndex(0);
        hasError = true;
      }

      if (!selectedCase.applicants[0].applicantAddress) {
        setApplicant1AddressInvalid(true);
        setSelectedIndex(0);
        hasError = true;
      }

      if (!selectedCase.applicants[0].applicantTown) {
        setApplicant1TownInvalid(true);
        setSelectedIndex(0);
        hasError = true;
      }

      if (!selectedCase.applicants[0].applicantPostcode) {
        setApplicant1PostcodeInvalid(true);
        setSelectedIndex(0);
        hasError = true;
      }

      if (!selectedCase.applicants[0].employmentStatusId) {
        setApplicant1EmploymentStatusInvalid(true);
        setSelectedIndex(0);
        hasError = true;
      }

      if (selectedCase.applicants[0].otherPropertyOwned === undefined) {

        console.log("SOLD BUG 1");
        console.log(selectedCase.applicants[0].willPropBeSold);


        setApplicant1OtherPropertyOwnedInvalid(true);
        setSelectedIndex(0);
        hasError = true;
      }
      // if (!selectedCase.appointmentTypeId) {
      //   setAppointmentInvalid(true);
      //   hasError = true;
      // }


      if (selectedCase.applicants[0].otherPropertyOwned === 1 && selectedCase.applicants[0].willPropBeSold === undefined) {

        console.log("SOLD BUG 2");
        setApplicant1OtherPropertySoldInvalid(true);
        setSelectedIndex(0);
        hasError = true;
      }

      if (hasError) {
        reject();
      } else {
        resolve();
      }
    });
  };

  const handleUpdate = () => {
    validate().then(
      function () {

        var dateTime = new Date();
        var momentDate = moment(dateTime).format(); // .toString();

        var _updateCase: CaseUpdate = {
          id: selectedCase.id,
          caseStatusId: 25,
          developmentId: selectedCase.developmentId,
          developerId: selectedCase.developerId,
          purchasePrice: selectedCase.purchasePrice,
          plotNumber: selectedCase.plotNumber,
          htb: selectedCase.htb,
          cashBuyer: selectedCase.cashBuyer,
          so: selectedCase.so,
          keyNotes: selectedCase.keyNotes,
          dateOfReferral: momentDate,
          offerExpiryDate: momentDate,
          updatedDate: momentDate,
          isDeleted: selectedCase.isDeleted,
          advisorId: selectedCase.advisorId,
          propertyStatusId: selectedCase.propertyStatusId,
          depositLevel: selectedCase.depositLevel,
          serviceCharge: selectedCase.serviceCharge,
          minPercShareAvailable: selectedCase.minPercShareAvailable,
          housingAssociation: selectedCase.housingAssociation,
          financialDetailsId: selectedCase.financialDetailsId,
          closedDate: momentDate,
          isClosed: selectedCase.isClosed,
          administratorId: selectedCase.administratorId,
          lnhManagerId: selectedCase.lnhManagerId,
          schemeId: selectedCase.schemeId,
          buyerTypeId: selectedCase.buyerTypeId,
          propertyTypeId: selectedCase.propertyTypeId,
          managerName: selectedCase.managerName
        }

        console.log("Update Case");
        console.log(_updateCase);


        globalDataRepo.UpdateCase(_updateCase).then(
          function (caseResponse: any) {

            globalDataRepo.UpdateApplicant(selectedCase.applicants[0]).then(
              function (app1Response: any) {
                globalDataRepo.UpdateApplicant(selectedCase.applicants[1]).then(
                  function (app2Response: any) {
                    globalFunctions.HandleToast({
                      header: "Case submitted",
                      id: "Refer-Case-Success",
                      description: "Thank you, your case has been submitted.",
                      type: "success",
                      error: "",
                    });

                    var _selectedCase = { ...selectedCase };

                    _selectedCase.caseStatusId = 25;

                    setSelectedCase(_selectedCase);

                    // props.onReferCaseComplete();
                  },
                  function (error: any) {
                    globalFunctions.HandleToast({
                      header: "Error",
                      id: "Update-Applicant-Error",
                      description:
                        "Something went wrong. Could not update applicant.",
                      type: "danger",
                      error: error,
                    });
                  }
                );
              },
              function (error: any) {
                globalFunctions.HandleToast({
                  header: "Error",
                  id: "Update-Applicant-Error",
                  description:
                    "Something went wrong. Could not update applicant.",
                  type: "danger",
                  error: error,
                });
              }
            );
          },
          function (error: any) {
            globalFunctions.HandleToast({
              header: "Error",
              id: "Update-Case-Error",
              description: "Something went wrong. Could not update case.",
              type: "danger",
              error: error,
            });
          }
        );
      },
      function (error) { }
    );

  };

  const getSchemes = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(16).then(
        function (response: any) {
          var schemesList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setSchemes(schemesList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Scheme-Lookup-Error",
            description: "Could not load schemes",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const getappintmentTypes = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(19).then(
        function (response: any) {

          var appointmenttypeList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });
          console.log(appointmenttypeList)
          setappointmentTypes(appointmenttypeList);
          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Scheme-Lookup-Error",
            description: "Could not load schemes",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const getDevelopments = () => {
    return new Promise<void>(function (resolve, reject) {
      var developmentsList: any = globalState.developments.map(
        (d: any, index: any) => {
          return (
            <option style={{ fontSize: "12px" }} key={index} value={d.id}>
              {d.name}
            </option>
          );
        }
      );

      setDevelopments(developmentsList);

      resolve();
    });
  };

  const getPropertyTypes = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(17).then(
        function (response: any) {
          var ptList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setPropertyTypes(ptList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Property-Types-Lookup-Error",
            description: "Could not load property types",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const getStressTestingRentPayments = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(21).then(
        function (response: any) {
          var btList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setStressTestingRentPayments(btList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Stress-Testing-Rent-Payments-Lookup-Error",
            description: "Could not load Stress testing rent payments",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const getBuyerTypes = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(18).then(
        function (response: any) {
          var btList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setBuyerTypes(btList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Buyer-Types-Lookup-Error",
            description: "Could not load buyer types",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const getEmploymentStatuses = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(7).then(
        function (response: any) {
          var esList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setEmploymentStatuses(esList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Employment-Status-Lookup-Error",
            description: "Could not load employment statuses",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const getPropertyStatuses = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(8).then(
        function (response: any) {
          var psList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setPropertyStatuses(psList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Property-Status-Lookup-Error",
            description: "Could not load property statuses",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const tabs = ["Applicant 1", "Applicant 2"];

  if (
    selectedCase?.applicants !== undefined &&
    selectedCase?.applicants !== null
  ) {
    return (
      <MainDetailsStyle>
        <Pane flex="1" overflowY="auto" background="tint1" padding={20}>
          <Row>
            <Col xs={12} sm={12} md={9} lg={9} style={{ marginBottom: "20px" }}>
              <Pane
                elevation={1}
                marginRight="1%"
                style={{
                  padding: "20px",
                  border: "1px solid lightgray",
                  borderRadius: "10px",
                  paddingBottom: "0px",
                }}
              >
                <Tablist marginBottom={16} flexBasis={240} marginRight={24}>
                  {tabs.map((tab, index) => (
                    <Tab
                      key={tab}
                      id={tab}
                      onSelect={() => applicantTabSelected(index)}
                      isSelected={index === selectedIndex}
                      aria-controls={`panel-${tab}`}
                      style={{ fontSize: "16px" }}
                    >
                      {tab}
                    </Tab>
                  ))}
                </Tablist>
                <Pane display={selectedIndex === 0 ? "flex" : "none"}>
                  <Row style={{ width: "100%" }}>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <TextInputField
                        label="Name"
                        required
                        value={selectedCase?.applicants[0].applicantName || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[0];
                          _applicant1.applicantName = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                        isInvalid={applicant1NameInvalid}
                        validationMessage={
                          applicant1NameInvalid ? validationMessage : null
                        }
                      />
                      <TextInputField
                        label="Email Address"
                        value={selectedCase?.applicants[0].applicantEmail}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[0];
                          _applicant1.applicantEmail = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                      <TextInputField
                        label="Primary Phone"
                        required
                        value={selectedCase?.applicants[0].applicantPhone1}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[0];
                          _applicant1.applicantPhone1 = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                        isInvalid={applicant1PhoneInvalid}
                        validationMessage={
                          applicant1PhoneInvalid ? validationMessage : null
                        }
                      />
                      <TextInputField
                        label="Secondary Phone"
                        value={selectedCase?.applicants[0].applicantPhone2}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[0];
                          _applicant1.applicantPhone2 = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <TextInputField
                        label="Address"
                        required
                        value={selectedCase?.applicants[0].applicantAddress}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[0];
                          _applicant1.applicantAddress = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                        isInvalid={applicant1AddressInvalid}
                        validationMessage={
                          applicant1AddressInvalid ? validationMessage : null
                        }
                      />
                      <TextInputField
                        label="Town"
                        required
                        value={selectedCase?.applicants[0].applicantTown}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[0];
                          _applicant1.applicantTown = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                        isInvalid={applicant1TownInvalid}
                        validationMessage={
                          applicant1TownInvalid ? validationMessage : null
                        }
                      />
                      <TextInputField
                        label="County"
                        value={selectedCase?.applicants[0].applicantCounty}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[0];
                          _applicant1.applicantCounty = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                      <TextInputField
                        label="Postcode"
                        required
                        value={selectedCase?.applicants[0].applicantPostcode}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[0];
                          _applicant1.applicantPostcode = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                        isInvalid={applicant1PostcodeInvalid}
                        validationMessage={
                          applicant1PostcodeInvalid ? validationMessage : null
                        }
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <SelectField
                        label="Employment Status"
                        onChange={(e) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[0];
                          _applicant1.employmentStatusId = Number(
                            e.target.value
                          );
                          _selectedCase.applicants[0] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        value={selectedCase?.applicants[0].employmentStatusId}
                        required
                        width="100%"
                        marginBottom={24}
                        disabled={disabledInput === true ? true : false}
                        isInvalid={applicant1EmploymentStatusInvalid}
                        validationMessage={
                          applicant1EmploymentStatusInvalid
                            ? validationMessage
                            : null
                        }
                      >
                        <option value="">Please Select...</option>
                        {employmentStatuses}
                      </SelectField>
                      <SelectField
                        label="Other Property Owned?"
                        onChange={(e) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[0];
                          _applicant1.otherPropertyOwned = Number(
                            e.target.value
                          );
                          _selectedCase.applicants[0] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        value={selectedCase?.applicants[0].otherPropertyOwned}
                        required
                        width="100%"
                        marginBottom={24}
                        disabled={disabledInput === true ? true : false}
                        isInvalid={applicant1OtherPropertyOwnedInvalid}
                        validationMessage={
                          applicant1OtherPropertyOwnedInvalid
                            ? validationMessage
                            : null
                        }
                      >
                        <option style={{ fontSize: "12px" }} key={0} value={0}>
                          No
                        </option>
                        <option style={{ fontSize: "12px" }} key={1} value={1}>
                          Yes
                        </option>
                      </SelectField>
                      {selectedCase?.applicants[0].otherPropertyOwned === 1 ? (
                        <SelectField
                          label="Will Property Be Sold?"
                          onChange={(e) => {
                            var _selectedCase = { ...selectedCase };
                            var _applicant1 = _selectedCase?.applicants[0];
                            _applicant1.willPropBeSold = Number(e.target.value);
                            _selectedCase.applicants[0] = _applicant1;
                            setSelectedCase(_selectedCase);
                          }}
                          value={selectedCase?.applicants[0].willPropBeSold}
                          required
                          width="100%"
                          marginBottom={24}
                          disabled={disabledInput === true ? true : false}
                          isInvalid={applicant1OtherPropertySoldInvalid}
                          validationMessage={
                            applicant1OtherPropertySoldInvalid
                              ? validationMessage
                              : null
                          }
                        >
                          <option
                            style={{ fontSize: "12px" }}
                            key={0}
                            value={0}
                          >
                            No
                          </option>
                          <option
                            style={{ fontSize: "12px" }}
                            key={1}
                            value={1}
                          >
                            Yes
                          </option>
                        </SelectField>
                      ) : null}
                    </Col>
                  </Row>
                </Pane>
                <Pane display={selectedIndex === 1 ? "flex" : "none"}>
                  <Row style={{ width: "100%" }}>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <TextInputField
                        label="Name"
                        value={selectedCase?.applicants[1].applicantName}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[1];
                          _applicant1.applicantName = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                      <TextInputField
                        label="Email Address"
                        value={selectedCase?.applicants[1].applicantEmail}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[1];
                          _applicant1.applicantEmail = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                      <TextInputField
                        label="Primary Phone"
                        value={selectedCase?.applicants[1].applicantPhone1}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[1];
                          _applicant1.applicantPhone1 = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                      <TextInputField
                        label="Secondary Phone"
                        value={selectedCase?.applicants[1].applicantPhone2}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[1];
                          _applicant1.applicantPhone2 = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <TextInputField
                        label="Address"
                        value={selectedCase?.applicants[1].applicantAddress}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[1];
                          _applicant1.applicantAddress = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                      <TextInputField
                        label="Town"
                        value={selectedCase?.applicants[1].applicantTown}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[1];
                          _applicant1.applicantTown = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                      <TextInputField
                        label="County"
                        value={selectedCase?.applicants[1].applicantCounty}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[1];
                          _applicant1.applicantCounty = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                      <TextInputField
                        label="Postcode"
                        value={selectedCase?.applicants[1].applicantPostcode}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[1];
                          _applicant1.applicantPostcode = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <SelectField
                        label="Employment Status"
                        onChange={(e) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[1];
                          _applicant1.employmentStatusId = Number(
                            e.target.value
                          );
                          _selectedCase.applicants[1] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        value={selectedCase?.applicants[1].employmentStatusId}
                        width="100%"
                        marginBottom={24}
                        disabled={disabledInput === true ? true : false}
                      >
                        <option value="">Please Select...</option>
                        {employmentStatuses}
                      </SelectField>
                      <SelectField
                        label="Other Property Owned?"
                        onChange={(e) => {
                          var _selectedCase = { ...selectedCase };
                          var _applicant1 = _selectedCase?.applicants[1];
                          _applicant1.otherPropertyOwned = Number(
                            e.target.value
                          );
                          _selectedCase.applicants[1] = _applicant1;
                          setSelectedCase(_selectedCase);
                        }}
                        value={selectedCase?.applicants[1].otherPropertyOwned}
                        width="100%"
                        marginBottom={24}
                        disabled={disabledInput === true ? true : false}
                      >
                        <option style={{ fontSize: "12px" }} key={0} value={0}>
                          No
                        </option>
                        <option style={{ fontSize: "12px" }} key={1} value={1}>
                          Yes
                        </option>
                      </SelectField>
                      {selectedCase?.applicants[1].otherPropertyOwned === 1 ? (
                        <SelectField
                          label="Will Property Be Sold?"
                          onChange={(e) => {
                            var _selectedCase = { ...selectedCase };
                            var _applicant1 = _selectedCase?.applicants[1];
                            _applicant1.willPropBeSold = Number(e.target.value);
                            _selectedCase.applicants[1] = _applicant1;
                            setSelectedCase(_selectedCase);
                          }}
                          value={selectedCase?.applicants[1].willPropBeSold}
                          width="100%"
                          marginBottom={24}
                          disabled={disabledInput === true ? true : false}
                        >
                          <option
                            style={{ fontSize: "12px" }}
                            key={0}
                            value={0}
                          >
                            No
                          </option>
                          <option
                            style={{ fontSize: "12px" }}
                            key={1}
                            value={1}
                          >
                            Yes
                          </option>
                        </SelectField>
                      ) : null}
                    </Col>
                  </Row>
                </Pane>
              </Pane>
            </Col>
            <Col xs={12} sm={12} md={3} lg={3}>
              <Pane
                elevation={1}
                style={{
                  padding: "20px",
                  border: "1px solid lightgray",
                  borderRadius: "10px",
                  paddingBottom: "0px",
                }}
              >
                <Heading
                  size={300}
                  marginTop="default"
                  style={{
                    marginBottom: "20px",
                    lineHeight: "20px",
                    marginTop: "0px",
                    fontSize: "16px",
                    color: "#425A70",
                    fontWeight: "500",
                  }}
                >
                  Key Notes
                </Heading>
                <Textarea
                  id="textarea"
                  placeholder="Any key notes to be added here..."
                  height={310}
                  value={selectedCase?.keyNotes}
                  onChange={(e: any) => {
                    var _selectedCase = { ...selectedCase };
                    _selectedCase.keyNotes = e.target.value;
                    setSelectedCase(_selectedCase);
                  }}
                  marginBottom={24}
                  disabled={disabledInput === true ? true : false}
                />
              </Pane>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: "0px",
              marginLeft: "0px",
              marginRight: "0px",
              boxShadow:
                "box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)",
              padding: "20px",
              border: "1px solid lightgray",
              borderRadius: "10px",
              paddingLeft: "0px",
              paddingRight: "0px",
            }}
          >
            <Col
              xs={12}
              sm={12}
              md={6}
              lg={6}
              style={{ paddingLeft: "0px", paddingRight: "0px" }}
            >
              <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{ paddingLeft: "20px", paddingRight: "20px" }}
                >
                  <SelectField
                    label="Property Status"
                    onChange={(e) => {
                      var _selectedCase = { ...selectedCase };
                      _selectedCase.propertyStatusId = Number(e.target.value);
                      setSelectedCase(_selectedCase);
                    }}
                    value={selectedCase?.propertyStatusId}
                    required
                    width="100%"
                    marginBottom={24}
                    disabled={disabledInput === true ? true : false}
                    isInvalid={propertyStatusIdInvalid}
                    validationMessage={
                      propertyStatusIdInvalid ? validationMessage : null
                    }
                  >
                    <option value="">Please Select...</option>
                    {propertyStatuses}
                  </SelectField>
                  {
                    selectedCase.casetypeId === 305 ? (<SelectField
                      label="Development Name"
                      onChange={(e) => {
                        var _selectedCase = { ...selectedCase };
                        _selectedCase.developmentId = Number(e.target.value);
                        setSelectedCase(_selectedCase);
                      }}
                      value={selectedCase?.developmentId}
                      required
                      width="100%"
                      marginBottom={24}
                      disabled={disabledInput === true ? true : false}
                      isInvalid={developmentIdInvalid}
                      validationMessage={
                        developmentIdInvalid ? validationMessage : null
                      }
                    >
                      <option value="">Please Select...</option>
                      {developments}
                    </SelectField>) : null

                  }

                  {/* <SelectField
                    label="Development Name"
                    onChange={(e) => {
                      var _selectedCase = { ...selectedCase };
                      _selectedCase.developmentId = Number(e.target.value);
                      setSelectedCase(_selectedCase);
                    }}
                    value={selectedCase?.developmentId}
                    required
                    width="100%"
                    marginBottom={24}
                    disabled={disabledInput === true ? true : false}
                    isInvalid={developmentIdInvalid}
                    validationMessage={
                      developmentIdInvalid ? validationMessage : null
                    }
                  >
                    <option value="">Please Select...</option>
                    {developments}
                  </SelectField> */}

                  <TextInputField
                    label="Manager"
                    required
                    value={selectedCase?.managerName || ""}
                    onChange={(e: any) => {
                      var _selectedCase = { ...selectedCase };
                      _selectedCase.managerName = e.target.value;
                      setSelectedCase(_selectedCase);
                    }}
                    disabled={disabledInput === true ? true : false}
                    isInvalid={managerNameInvalid}
                    validationMessage={
                      managerNameInvalid ? validationMessage : null
                    }
                  />

                  {selectedCase.casetypeId === 305 ? <>
                    <Heading
                      size={300}
                      marginTop="default"
                      style={{
                        marginBottom: "4px",
                        lineHeight: "20px",
                        marginTop: "0px",
                        fontSize: "14px",
                        color: "#425A70",
                        fontWeight: "500",
                      }}
                    >
                      Cash Buyer?
                    </Heading>

                    <Checkbox
                      marginLeft={15}
                      marginTop={2}
                      label="Yes"
                      checked={cashBuyer}
                      disabled={disabledInput === true ? true : false}
                      onChange={(e) => {
                        var _selectedCase = { ...selectedCase };
                        setCashBuyer(e.target.checked);

                        _selectedCase.cashBuyer = e.target.checked ? 1 : 0;
                        console.log('checked' + ' ' + _selectedCase.cashBuyer + ' ' + e.target.checked);
                        setSelectedCase(_selectedCase);
                      }}
                    /></> : null}


                </Col>
                <Col xs={12} sm={12} md={6} lg={6}>
                  <div className="currency-wrap">
                    <span className="currency-code">£</span>
                    <TextInputField
                      className="text-currency"
                      label="Full Market Value"
                      required
                      type="number"
                      value={selectedCase?.purchasePrice}
                      onChange={(e: any) => {
                        var _selectedCase = { ...selectedCase };
                        _selectedCase.purchasePrice = e.target.value;
                        setSelectedCase(_selectedCase);
                      }}
                      disabled={disabledInput === true ? true : false}
                      isInvalid={purchasePriceInvalid}
                      validationMessage={
                        purchasePriceInvalid ? validationMessage : null
                      }
                    />
                  </div>

                  {selectedCase.casetypeId === 305 ?
                    <TextInputField
                      label="Property Plot Number"
                      required
                      value={selectedCase?.plotNumber}
                      onChange={(e: any) => {
                        var _selectedCase = { ...selectedCase };
                        _selectedCase.plotNumber = e.target.value;
                        setSelectedCase(_selectedCase);
                      }}
                      disabled={disabledInput === true ? true : false}
                      isInvalid={plotNumberInvalid}
                      validationMessage={
                        plotNumberInvalid ? validationMessage : null
                      }
                    /> : null}
                  {selectedCase.casetypeId === 305 ?
                    <SelectField
                      label="Buyer Type"
                      width="100%"
                      required
                      disabled={disabledInput === true ? true : false}
                      value={selectedCase?.buyerTypeId}
                      onChange={(e: any) => {
                        var _selectedCase = { ...selectedCase };
                        _selectedCase.buyerTypeId = e.target.value;
                        setSelectedCase(_selectedCase);
                      }}
                      isInvalid={buyerTypeInvalid}
                      validationMessage={buyerTypeInvalid ? validationMessage : null}
                    >
                      <option value="">Please Select...</option>
                      {buyerTypes}
                    </SelectField> : null}
                </Col>
              </Row>

              {/* <Row
                style={{
                  marginLeft: "20px",
                  marginRight: "20px",
                  marginBottom: "10px",
                }}
              >
                 <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  style={{
                    display: "inline-flex",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  <Heading
                    size={300}
                    marginTop="default"
                    style={{
                      marginBottom: "4px",
                      lineHeight: "20px",
                      marginTop: "0px",
                      fontSize: "14px",
                      color: "#425A70",
                      fontWeight: "500",
                    }}
                  >
                    Cash Buyer?
                  </Heading>
                  <Checkbox
                    marginLeft={15}
                    marginTop={2}
                    label="Yes"
                    checked={selectedCase?.cashBuyer === 1}
                    onChange={(e) => {
                      var _selectedCase = selectedCase;
                      _selectedCase.cashBuyer = e.target.checked ? 1 : 0;
                      setSelectedCase(_selectedCase);
                    }}
                    disabled
                  />
                </Col> 
              </Row> */}
            </Col>

            <Col
              xs={12}
              sm={12}
              md={6}
              lg={6}
              style={{ paddingLeft: "20px", paddingRight: "20px" }}
            >
              <Row>
                <Col xs={12} sm={12} md={6} lg={6}>
                  {selectedCase.casetypeId === 305 ? <>

                    <div className="currency-wrap">
                      <span className="currency-code">£</span>
                      <TextInputField
                        className="text-currency"
                        label="Deposit Level (£)"
                        required
                        type="number"
                        value={selectedCase?.depositLevel}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          _selectedCase.depositLevel = e.target.value;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                        isInvalid={depositLevelInvalid}
                        validationMessage={
                          depositLevelInvalid ? validationMessage : null
                        }
                      />
                    </div></> : null}
                  <div className="currency-wrap">
                    <span className="currency-code">£</span>
                    <TextInputField
                      className="text-currency"
                      label="Monthly Service Charge / Other Fees"
                      required
                      type="number"
                      value={selectedCase?.serviceCharge}
                      onChange={(e: any) => {
                        var _selectedCase = { ...selectedCase };
                        _selectedCase.serviceCharge = e.target.value;
                        setSelectedCase(_selectedCase);
                      }}
                      disabled={disabledInput === true ? true : false}
                      isInvalid={serviceChargeInvalid}
                      validationMessage={
                        serviceChargeInvalid ? validationMessage : null
                      }
                    />
                  </div>


                  <SelectField
                    label="Property Type"
                    width="100%"
                    required
                    value={selectedCase?.propertyTypeId}
                    onChange={(e: any) => {
                      var _selectedCase = { ...selectedCase };
                      _selectedCase.propertyTypeId = e.target.value;
                      setSelectedCase(_selectedCase);
                    }}
                    disabled={disabledInput === true ? true : false}
                    isInvalid={propertyTypeInvalid}
                    validationMessage={propertyTypeInvalid ? validationMessage : null}
                  >
                    <option value="">Please Select...</option>
                    {propertyTypes}
                  </SelectField>

                  {/* <SelectField
                    label="Frequency"
                    width="42%"
                    value={selectedCase?.frequency}
                    onChange={(e) => {
                      var _selectedCase = selectedCase;
                      _selectedCase.frequency = e.target.value;
                      setSelectedCase(_selectedCase);
                    }}
                    disabled
                  >
                    <option value=""></option>
                    <option value="Annual">Annual</option>
                    <option value="Monthly">Monthly</option>
                  </SelectField> */}
                </Col>

                <Col xs={12} sm={12} md={6} lg={6}>

                  {
                    selectedCase.casetypeId === 305 ?

                      <SelectField
                        label="Homes Purchase Scheme"
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          _selectedCase.schemeId = Number(e.target.value);
                          _selectedCase.so = Number(e.target.value) === 171 ? 1 : 0;
                          setSelectedCase(_selectedCase);
                        }}
                        value={selectedCase?.schemeId}
                        width="100%"
                        marginBottom={24}
                        disabled={disabledInput === true ? true : false}
                        isInvalid={schemeInvalid}
                        validationMessage={schemeInvalid ? validationMessage : null}

                      >
                        <option value="">Please Select...</option>
                        {schemes}
                      </SelectField> : null}

                  {/* <SelectField
                    label="Appointment Type"
                    onChange={(e: any) => {
                      var _selectedCase = { ...selectedCase };
                      _selectedCase.appointmentTypeId = Number(e.target.value);
                      setSelectedCase(_selectedCase);
                    }}
                    value={selectedCase?.appointmentTypeId}
                    required
                    width="100%"
                    marginBottom={24}
                    isInvalid={appointmentInvalid}
                    validationMessage={appointmentInvalid ? validationMessage : null}
                  >
                    <option value="">Please Select...</option>
                    {appointmentTypes}
                  </SelectField> */}


                  {
                    selectedCase.casetypeId === 306 ? (
                      <>
                        <div className="currency-wrap">
                          <span className="currency-code">%</span>
                          <TextInputField
                            className="text-currency"
                            label="Current % Shareholding"
                            type="number"
                            required
                            value={selectedCase?.currentShareHolding || ""}
                            onChange={(e: any) => {
                              var _selectedCase = { ...selectedCase };
                              _selectedCase.currentShareHolding = e.target.value;
                              setSelectedCase(_selectedCase);
                            }}
                            disabled={disabledInput === true ? true : false}
                          />
                        </div></>) : null
                  }

                  {/* 
<div className="currency-wrap">
                     <TextInputField
                       className="text-currency"
                       label="Remaining Years on Current Lease"                   
                       type="number"
                       required
                       value={caseReferral?.remainingYearonCurrentLease || ""}
                       onChange={(e: any) => {
                         var _selectedCase = { ...caseReferral };
                         _selectedCase.remainingYearonCurrentLease = e.target.value;
                         setCaseReferral(_selectedCase);
                       }}
                       isInvalid={remainingyearoncurrentleaseInvalid}
                       validationMessage={
                        remainingyearoncurrentleaseInvalid ? validationMessage : null
                       }
                     />
                   </div> */}

                  {
                    selectedCase.casetypeId === 306 ? (
                      <>
                        <div className="currency-wrap">

                          <TextInputField
                            className="text-currency"
                            label="Remaining Years on Current Lease"
                            type="number"
                            required
                            value={selectedCase?.remainingYearonCurrentLease || ""}
                            onChange={(e: any) => {
                              var _selectedCase = { ...selectedCase };
                              _selectedCase.remainingYearonCurrentLease = e.target.value;
                              setSelectedCase(_selectedCase);
                            }}
                            disabled={disabledInput === true ? true : false}
                          />
                        </div></>) : null
                  }


                  {selectedCase.schemeId === 171 ? (
                    <div className="currency-wrap">
                      <span className="currency-code">%</span>
                      <TextInputField
                        className="text-currency"
                        label="Min % Share Available"
                        value={selectedCase?.minPercShareAvailable}
                        onChange={(e: any) => {
                          var _selectedCase = { ...selectedCase };
                          _selectedCase.minPercShareAvailable = e.target.value;
                          setSelectedCase(_selectedCase);
                        }}
                        disabled={disabledInput === true ? true : false}
                        isInvalid={minPercShareInvalid}
                        validationMessage={
                          minPercShareInvalid ? validationMessage : null
                        }
                      />
                    </div>
                  ) : null}

                  {selectedCase.schemeId === 171 ? (
                    <TextInputField
                      style={{ marginBottom: "0px" }}
                      label="Housing Association"
                      value={selectedCase?.housingAssociation}
                      onChange={(e: any) => {
                        var _selectedCase = { ...selectedCase };
                        _selectedCase.housingAssociation = e.target.value;
                        setSelectedCase(_selectedCase);
                      }}
                      disabled={disabledInput === true ? true : false}
                      isInvalid={housingAssociationInvalid}
                      validationMessage={
                        housingAssociationInvalid ? validationMessage : null
                      }
                    />
                  ) : null}

                  <SelectField
                    label="Stress Testing Rent Payments"
                    width="100%"
                    onChange={(e: any) => {
                      var _selectedCase = { ...selectedCase };
                      _selectedCase.strpTypeId = Number(e.target.value);
                      setSelectedCase(_selectedCase);
                    }}
                    value={selectedCase?.strpTypeId}
                    marginBottom={24}
                    disabled={disabledInput === true ? true : false}

                  >
                    <option value="">Please Select...</option>
                    {stressTestingRentPayments}
                  </SelectField>
                </Col>
              </Row>
            </Col>
          </Row>
        </Pane>
        <Pane paddingBottom={25}>
          <Row
            style={{
              marginTop: "0px",
              marginLeft: "20px",
              marginRight: "20px",
              boxShadow:
                "box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)",
              padding: "10px",
              border: "1px solid lightgray",
              borderRadius: "10px",
              paddingLeft: "10px",
              paddingRight: "0px",
              paddingBottom: "20px",
            }}
          >


            <Col xs={12} sm={6} md={6} lg={3}>
              <Heading paddingBottom={10}> Case referred by</Heading>{" "}
              {selectedCase?.referralUser.name}
            </Col>
            {/* 
            <Col xs={12} sm={6} md={6} lg={3}>
              <Heading paddingBottom={10}> Case type</Heading>{" "}
              {selectedCase?.casetypeId === 306 ? "Staircasing" : "TCB"}
            </Col> */}

            <Col xs={12} sm={6} md={6} lg={2}>
              <Heading paddingBottom={10}> Referred on</Heading>
              {moment(selectedCase?.dateOfReferral).format("DD/MM/YYYY")}
            </Col>

            <Col xs={12} sm={6} md={6} lg={2}>
              <Heading paddingBottom={10}> Advisor</Heading>
              {selectedCase?.advisor?.name
                ? selectedCase.advisor.name
                : "Unassigned"}
            </Col>

            <Col xs={12} sm={6} md={6} lg={2}>
              <Heading paddingBottom={10}> Case type</Heading>{" "}
              {selectedCase?.casetypeId === 306 ? "Staircasing" : "Mortgage Lead"}
            </Col>

            {globalState.caseStatuses.find(
              (e: any) => e.id === selectedCase?.caseStatusId
            )?.description !== "Draft" &&
              selectedCase?.administrator !== null ? (
              <Col xs={12} sm={6} md={6} lg={2}>
                <Heading paddingBottom={10}>Case Administrator</Heading>
                {selectedCase?.administrator.name}
              </Col>
            ) : null}

            <Col xs={12} sm={6} md={6} lg={3}>
              <Heading paddingBottom={10}> Case Status</Heading>
              {isClosed === true
                ? "Case Closed "
                : globalState.caseStatuses.find(
                  (e: any) => e.id === selectedCase?.caseStatusId
                )?.description}
            </Col>
          </Row>
          <Pane display="flex" float="right" marginTop={20} marginBottom={70} paddingRight={20} paddingBottom={20}  >
            {(selectedCase?.caseStatusId === 66 && globalState.user.userId === selectedCase?.referredById) ?
              <Button
                appearance="primary"
                intent="success"
                iconBefore={AddIcon}
                width={122}
                paddingLeft={21}
                onClick={
                  () => handleUpdate()
                }
              >
                Refer Case
              </Button>
              : null}

          </Pane>
        </Pane>


        {showFormLoading ? (
          <Pane
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
            background="rgba(0,0,0,0.05)"
            style={{ position: "absolute", width: "100%", top: "0" }}
          >
            <Spinner></Spinner>
          </Pane>
        ) : null}
      </MainDetailsStyle>
    );
  } else {
    return null;
  }
};

export default CaseMainDetails;
